import { AppRouteProps } from "@harea/component";
import React from "react";
import ProjectAppointmentCreateMissingContainer from "./container/ProjectAppointmentCreateMissingContainer";
import ProjectDayOffCreateContainer from "views/dayoff/views/demand/views/create/container/ProjectDayOffCreateContainer";

export const ProjectAppointmentCreateMissingRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "Harea.Project.Appointment.Create.Missing.Label",
        roles: ["TIMEOFF"],
        element: <ProjectDayOffCreateContainer />,
        children: [
            // ...ProjectAppointmentCreateVacationRoutes,
            // ...ProjectAppointmentCreateMissingRoutes,
            {
                path: "",
                title: "BSMRH.Project.Appointment.Create.Label",
                element: <ProjectAppointmentCreateMissingContainer />,
            }
        ]
    },
];
